export enum UserNotificationActionEnum {
  USER_NOTIFICATIONS_GET_DATA = 'USER_NOTIFICATIONS_GET_DATA',
  USER_NOTIFICATIONS_GET_UNREAD_COUNT = 'USER_NOTIFICATIONS_GET_UNREAD_COUNT',
  USER_NOTIFICATIONS_SET_UNREAD_COUNT = 'USER_NOTIFICATIONS_SET_UNREAD_COUNT',
  USER_NOTIFICATIONS_SET_DATA = 'USER_NOTIFICATIONS_SET_DATA',
  USER_NOTIFICATIONS_SET_SELECT_OPTION = 'USER_NOTIFICATIONS_SET_SELECT_OPTION',
  USER_NOTIFICATIONS_RESET_INITIAL_FORM_VALUES = 'USER_NOTIFICATIONS_RESET_INITIAL_FORM_VALUES',
  USER_NOTIFICATIONS_READ_STATUS_UPDATE = 'USER_NOTIFICATIONS_READ_STATUS_UPDATE',
  USER_NOTIFICATIONS_GET_FETCH_SETTING_BY_CODE = 'USER_NOTIFICATIONS_GET_FETCH_SETTING_BY_CODE',
  USER_NOTIFICATIONS_SET_FETCH_SETTING_BY_CODE = 'USER_NOTIFICATIONS_SET_FETCH_SETTING_BY_CODE',
  USER_NOTIFICATIONS_SET_SEARCH_TEXT = 'USER_NOTIFICATIONS_SET_SEARCH_TEXT',
  USER_NOTIFICATIONS_SET_PAGE = 'USER_NOTIFICATIONS_SET_PAGE',
}
